// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.align-center[data-v-040fce93]{align-items:center;display:inline-flex}.stars[data-v-040fce93]{font-size:1.4em;padding:7px}`, "",{"version":3,"sources":["webpack://./src/shared/components/ncTable/partials/rowTypePartials/NumberStarsForm.vue"],"names":[],"mappings":"AAEA,+BACC,kBAAA,CACA,mBAAA,CAGD,wBACC,eAAA,CACA,WAAA","sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
